module.exports = __webpack_public_path__ + "img/SepticSystem.d2b657d1.png";